import lazyLoadOnRender from '../lazy/loadOnRender';

const RebrandingAdminBanner = () =>
  import(/* webpackChunkName: "4-feat-rebranding-banner" */ './AdminRebrandingBanner');

export default lazyLoadOnRender({ loader: RebrandingAdminBanner });
